import { useMutation } from "@tanstack/react-query";
import uploadsApiClient, { UploadFileInput } from "../../../api/uploads";

const useUploadTemporarySoundMutation = () => {
  return useMutation({
    mutationFn: (input: UploadFileInput) =>
      uploadsApiClient.uploadTemporarySound(input),
  });
};

export default useUploadTemporarySoundMutation;
